import React from "react";
import { Flex } from "@chakra-ui/react";

export const HoverBox = ({
  children,
  marginRight = "10px",
  marginBottom = "10px",
  flexDirection = "row",
  padding = "0px",
  hover = true,
  ...props
}) => (
  <Flex
    padding={padding}
    flexDirection={flexDirection}
    borderRadius="10px"
    boxShadow="1px 2px 10px rgba(0,0,0,0.2)"
    transition="0.2s"
    justify="flex-start"
    align="flex-start"
    alignItems="stretch"
    width="100%"
    height="100%"
    backgroundColor="#ffffff"
    _hover={
      hover
        ? {
            transform: "translateY(-5px)",
            boxShadow: "1px 5px 10px rgba(0,0,0,0.2)",
          }
        : {}
    }
    {...props}
  >
    {children}
  </Flex>
);
